// extracted by mini-css-extract-plugin
export default {"sizeBelow":"TablePagination_sizeBelow__xQmIU","countLoading":"TablePagination_countLoading__Sifd7"};